function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import HtmlText from "../../../components/HtmlText";
import { apiAssistantOplogList } from "../../../services";
import { Table, DatePicker as AntdDatePicker } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import Search from "../../../components/Form/Search";
import styles from "./index.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function LogDetail(props) {
  var orderCode = props.orderCode;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    logList = _useState2[0],
    setLogList = _useState2[1];
  var logTimeRangeInitValuesRef = useRef([dayjs().startOf('month'), dayjs().endOf('month')]);
  var getLogList = function getLogList(logTimeRange) {
    // 解析 logTimeRange 成 logTimeStart 和 logTimeEnd
    var logTimeStart, logTimeEnd;
    if (logTimeRange && logTimeRange.length === 2) {
      logTimeStart = dayjs(logTimeRange[0]).format('YYYY-MM-DD');
      logTimeEnd = dayjs(logTimeRange[1]).format('YYYY-MM-DD');
    }
    apiAssistantOplogList({
      bizCodes: [orderCode],
      bizType: 102001,
      createTimeStart: logTimeStart,
      createTimeEnd: logTimeEnd
    }).then(function (res) {
      var code = res.code,
        data = res.data;
      if (code === 0) {
        setLogList(data.data);
      }
    });
  };
  useEffect(function () {
    var startOfMonth = logTimeRangeInitValuesRef.current[0].format('YYYY-MM-DD');
    var endOfMonth = logTimeRangeInitValuesRef.current[1].format('YYYY-MM-DD');
    var logTimeRange = [startOfMonth, endOfMonth];
    getLogList(logTimeRange);
  }, []);
  var columns = [{
    title: '操作人',
    dataIndex: 'createByName',
    width: 80
  }, {
    title: '操作时间',
    dataIndex: 'createTime',
    width: 170
  }, {
    title: '变更内容',
    dataIndex: 'content',
    render: function render(v) {
      return /*#__PURE__*/_jsx(HtmlText, {
        value: v
      });
    }
  }];
  return /*#__PURE__*/_jsx("div", {
    className: "page-content-box",
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsxs("div", {
          children: ["\u8BA2\u5355\u7F16\u53F7: ", orderCode]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.content,
          children: [/*#__PURE__*/_jsx(Search, {
            initialValues: {
              logTimeRange: logTimeRangeInitValuesRef.current
            },
            formContainer: styles.formContainer,
            onFinish: function onFinish(q) {
              getLogList(q.logTimeRange);
            },
            showReset: false,
            children: /*#__PURE__*/_jsx(Search.Field, {
              name: "logTimeRange",
              label: "\u53D8\u66F4\u65E5\u5FD7\u65F6\u95F4\u6BB5",
              labelCol: {
                className: styles.minLabel110
              },
              children: /*#__PURE__*/_jsx(AntdDatePicker.RangePicker, {
                format: "YYYY/MM/DD",
                allowClear: false,
                placement: "bottomRight",
                className: styles.logTimeRange
              })
            })
          }), /*#__PURE__*/_jsx(Table, {
            rowKey: "id",
            columns: columns,
            dataSource: logList,
            scroll: {
              x: 'max-content'
            },
            bordered: true
          })]
        })]
      })
    })
  });
}